import ChannelListings from "./components/channel-listing/channel-listing-component";
import RemoteSearch from "./components/remote-search/remote-search-component";

const { render } = wp.element;

var channelListingBlock = document.getElementById("channel-listings");
if (channelListingBlock) {
  render(<ChannelListings />, channelListingBlock);
}
var remoteSearchBlock = document.getElementById("remotes");
if (remoteSearchBlock) {
  render(<RemoteSearch />, remoteSearchBlock);
}



// WEBPACK FOOTER //
// ./react/react.jsx